import React from 'react'
import {
  CancelOutlined,
  CheckCircleOutline,
  DoDisturbAltOutlined,
  DraftsOutlined,
  ScheduleOutlined,
  Verified,
} from '@mui/icons-material'
import { ClassNameValue } from 'tailwind-merge'
import type { ESignStatus } from '../../lib/api/types/esign.interfaces'
import cn from '../../lib/utils/cn'
import { Tooltip } from '../ui'
import Loader from './Loader'

interface SigningStatusIconProps {
  status: ESignStatus
  withoutTooltip?: boolean
  className?: ClassNameValue
}

export const SigningStatusIcon = ({ status, withoutTooltip = false, className }: SigningStatusIconProps) => {
  let tooltip = ''
  let icon: React.ReactNode = null

  switch (status) {
    case 'SIGNED':
      tooltip = 'Document Signed'
      icon = <Verified className={cn('w-4 h-4 fill-accent', className)} />
      break
    case 'PARTIALLY_SIGNED':
      tooltip = 'Partially Signed'
      icon = <CheckCircleOutline className={cn('w-4 h-4 text-amber-500', className)} />
      break
    case 'SENT':
      tooltip = 'Sent for Signing'
      icon = <DraftsOutlined className={cn('w-4 h-4 text-sky-500', className)} />
      break
    case 'DRAFT':
      tooltip = 'Draft'
      icon = <ScheduleOutlined className={cn('w-4 h-4 text-slate-500', className)} />
      break
    case 'DECLINED':
      tooltip = 'Declined'
      icon = <CancelOutlined className={cn('w-4 h-4 text-orange-600', className)} />
      break
    case 'CANCELED':
      tooltip = 'Canceled'
      icon = <DoDisturbAltOutlined className={cn('w-4 h-4 text-rose-600', className)} />
      break
    case 'SIGNED_FILE_GENERATING':
      tooltip = 'Signed file generating'
      icon = <Loader size={14} classNameWrapper={cn('mr-0.5', className)} />
      break
    default:
      return null
  }

  const content = <span className="inline-flex items-center justify-center">{icon}</span>

  if (withoutTooltip) {
    return content
  }

  return (
    <Tooltip label={tooltip} className="w-fit flex items-center justify-center" classNameChildrenWrapper="h-4">
      {content}
    </Tooltip>
  )
}
